import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import {
  Row,
  Col,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Helmet } from 'react-helmet-async';
import ConfirmModal from '../components/ConfirmModal';


import ResponseForm from '../forms/ResponseForm';
import StatusMessage from './StatusMessage';
import Breadcrumbs from '../components/Breadcrumbs';
import ResponseData from '../components/ResponseData';
import NotFoundPage from '../components/NotFoundPage';


// Response editing/deleting has no API on the applicant side (as before):
// the form and the delete button only toggle the UI.
const noop = () => {};

const ResponseReview = () => {
  const [isEditable, setIsEditable] = useState(false);
  const { responseId } = useParams();
  const response = useSelector(({ responses: { responses = [] } }) => (
    responses.find(item => item.id === +responseId)
  ));

  if (!response) {
    return <NotFoundPage />;
  }

  const toggleIsEditable = () => setIsEditable(value => !value);

  const { first_name, last_name } = response.fields;
  const name = last_name ? `${first_name} ${last_name}` : first_name;

  const breadcrumbs = [
    { title: 'Отклики', link: '/responses' },
    { title: name, link: '' },
  ];
  const title = `${name} | Jobs Widget`;

  return (
    <div className="response-page">
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <Breadcrumbs breadcrumbs={breadcrumbs} />
      <Row className="justify-content-md-between">
        <Col md="6" lg="5" className="response-left">
          <div className="response-left__edit-icon">
            <FontAwesomeIcon
              className="item-icon"
              icon="pencil-alt"
              onClick={toggleIsEditable}
            />
          </div>
          {isEditable
            ? (
              <>
                <ResponseForm
                  onSubmit={noop}
                  initialValues={response.fields}
                  response={response}
                />
                <div className="buttons-container">
                  <button
                    className="button"
                    type="button"
                    onClick={noop}
                  >
                    Сохранить
                  </button>
                  <button
                    className="button button_color_dark-blue"
                    type="button"
                    onClick={toggleIsEditable}
                  >
                    Отменить
                  </button>
                </div>
              </>
            )
            : (
              <div className="applicant">
                <ResponseData response={response} />
              </div>
            )}
          <div className="buttons-container">
            <ConfirmModal
              type="button"
              headerText="Удалить отклик?"
              buttonText="Удалить отклик"
              modalAction={noop}
            />
          </div>
          <StatusMessage
            status="editResponseStatus"
            errorMessage="Ошибка при сохранении изменений"
          />
          <StatusMessage
            status="deleteResponseStatus"
            errorMessage="Ошибка при удалении отклика"
          />
        </Col>
      </Row>
    </div>
  );
};

export default ResponseReview;
